<template>
  <section
    v-if="item || items.length"
    :class="sectionClass"
    :data-layout="layout.type"
    :data-screen-id="layout.type === 'gallery' ? screen.id : null"
  >
    <div
      :class="[
        'container',
        {
          reading: reading,
          split: split,
          'cta-inner': ['cta', 'positioning'].includes(layout.type),
          'form-layout': layout.type === 'contact',
        },
      ]"
    >
      <RecordImage
        v-if="layout.type === 'history' && item"
        :item="item"
        :screen="screen"
        class="editorial-image"
      />
      <template v-if="layout.type === 'hero'">
        <router-link to="/" class="breadcrumb">Home <span aria-hidden="true">/</span></router-link>
        <ApprovedHeading :item="item" :screen="screen" :layout="layout" tag="h1" />
      </template>
      <template v-else-if="layout.type === 'positioning'">
        <div
          :id="screen.chave"
          :data-screen-id="screen.id"
          :data-record-id="itemId(item)"
          class="positioning-inner"
        >
          <h2>{{ text(item, 'iti_nome') }}</h2>
          <RichText :value="value(item, 'iti_resumo1')" /><RecordButtons
            :item="item"
            :screen="screen"
            button-class="btn btn-dark"
          />
        </div>
      </template>
      <template v-else-if="['approach', 'split', 'history'].includes(layout.type)">
        <div>
          <ApprovedHeading :item="item" :screen="screen" :layout="layout" />
          <ApprovedList
            v-if="listScreen"
            :items="items"
            :screen="listScreen"
            :kind="layout.type === 'approach' ? 'steps' : 'text'"
          />
          <RecordButtons v-if="item" :item="item" :screen="screen" />
        </div>
        <RecordImage
          v-if="layout.type !== 'history' && item"
          :item="item"
          :screen="screen"
          class="editorial-image"
        />
      </template>
      <template v-else-if="layout.type === 'cta'">
        <ApprovedHeading :item="item" :screen="screen" :layout="layout" />
        <RecordButtons v-if="item" :item="item" :screen="screen" button-class="btn btn-dark" />
      </template>
      <template v-else-if="layout.type === 'contact'">
        <div>
          <ApprovedHeading :item="item" :screen="screen" :layout="layout" /><ContactDetails
            :item="item"
          />
        </div>
        <ContactForm :solutions="solutions" />
      </template>
      <template v-else>
        <ApprovedHeading
          v-if="item"
          :item="item"
          :screen="screen"
          :layout="layout"
          :centered="layout.centered"
          :spaced="layout.centered"
          :identify="layout.type !== 'gallery'"
        />
        <ContactDetails v-if="item && layout.type === 'contactDirectory'" :item="item" />
        <div
          v-if="layout.type === 'gallery' && photos.length"
          class="history-gallery"
          :data-gallery-screen="screen.id"
        >
          <figure v-for="photo in photos" :key="rawValue(photo, 'itg_id')">
            <img
              :src="imagePath(rawValue(photo, 'itg_urlimagem'))"
              :alt="text(photo, 'itg_alt') || text(photo, 'itg_nome')"
              loading="lazy"
            />
            <figcaption v-if="text(photo, 'itg_nome')">{{ text(photo, 'itg_nome') }}</figcaption>
          </figure>
        </div>
        <InsightsList v-if="filterInsights && listScreen" :items="items" :screen="listScreen" />
        <ApprovedList
          v-else-if="listScreen"
          :items="items"
          :screen="listScreen"
          :kind="listKind"
          :contact="layout.type === 'contactDirectory'"
        />
      </template>
    </div>
  </section>
</template>
<script>
import ApprovedHeading from './ApprovedHeading.vue';
import ApprovedList from './ApprovedList.vue';
import InsightsList from './InsightsList.vue';
import RecordImage from './RecordImage.vue';
import RecordButtons from './RecordButtons.vue';
import ContactDetails from './ContactDetails.vue';
import ContactForm from './ContactForm.vue';
import RichText from './RichText.vue';
import {
  contentValue,
  plainText,
  itemId,
  imagesFor,
  rawValue,
  imagePath,
} from '@/services/contentApi';
export default {
  name: 'ApprovedBlock',
  components: {
    ApprovedHeading,
    ApprovedList,
    InsightsList,
    RecordImage,
    RecordButtons,
    ContactDetails,
    ContactForm,
    RichText,
  },
  props: {
    filterInsights: Boolean,
    layout: Object,
    item: Object,
    screen: Object,
    items: { type: Array, default: () => [] },
    listScreen: Object,
    solutions: { type: Array, default: () => [] },
  },
  computed: {
    sectionClass() {
      return [
        'approved-block',
        this.layout.type === 'hero'
          ? 'page-hero'
          : this.layout.type === 'cta'
            ? 'cta'
            : this.layout.type === 'positioning'
              ? 'positioning'
              : 'section',
        {
          approach: this.layout.type === 'approach',
          history: this.layout.type === 'history',
          ecosystem: this.layout.type === 'brands',
        },
      ];
    },
    reading() {
      return ['reading', 'gallery', 'text', 'faq'].includes(this.layout.type);
    },
    split() {
      return ['approach', 'history', 'split'].includes(this.layout.type);
    },
    listKind() {
      return (
        this.layout.listStyle ||
        { contactDirectory: 'cards', reading: 'text' }[this.layout.type] ||
        this.layout.type
      );
    },
    photos() {
      return imagesFor(this.item, this.screen).slice(0, this.screen?.listasImagens?.[0]?.qtd || 0);
    },
  },
  methods: {
    itemId,
    rawValue,
    imagePath,
    value: contentValue,
    text(item, field) {
      return plainText(contentValue(item, field));
    },
  },
};
</script>
